/**
 * "Move to space ›" for a page / folder that is itself in the active project
 * (card 4.3), as a ContextMenu item, pure: Main and the project's spaces minus
 * the one it is in. No row when the project has no spaces (only Main) or the
 * item is not a project member (a page inside a folder follows its folder).
 */
export function docSpaceMenuRows({ nodeId, isMember, spaces = [], assignment = new Map(), labels = {}, icon, onMove }) {
  if (!isMember || !spaces.length) return [];
  const L = { move: 'Move to space', main: 'Main', ...labels };
  const here = assignment.get(nodeId) || null;
  const targets = [{ id: null, name: L.main }, ...spaces.map((s) => ({ id: String(s.id), name: s.name }))].filter((s) => s.id !== here);
  return [
    {
      key: 'space-move',
      icon,
      label: L.move,
      items: targets.map((s) => ({ key: `s-${s.id || 'main'}`, label: s.name, onClick: () => onMove(s.id) })),
    },
  ];
}
